<template>
  <div v-if="inited">
    <ylCapitalMobile
      v-if="isMobileScreen"
      v-bind="$attrs"
      :info="info"
       />
    <ylCapitalPC
      v-else
      v-bind="$attrs"
      :info="info"
       />
  </div>
</template>
<script>
export default {
  name: "ylHomeCapital",
  computed: {
    screenWidth() {
      return this.$store.getters.screenWidth;
    },
    screenHeight() {
      return this.$store.getters.screenHeight;
    },
    isMobileScreen() {
      return this.$store.getters.isMobileScreen;
    },
  },
  data() {
    return {
      inited: false,
      info: {
        content: ''
      },
    }
  },
  components: {
    ylCapitalMobile: () => import("./components/mobile.vue"),
    ylCapitalPC: () => import("./components/pc.vue"),
  },
  mounted () {
    this.inited = false
    this.getData()
  },
  methods: {
    async getData() {
      let res = await this.$api.indexCompanyIntroduce()
      this.info = Object.assign({}, res)
      console.log(`indexCompanyIntroduce => `)
      console.log(this.info)
      console.log(this.info.content)
      this.inited = true
    },
  }
};
</script>